import { collection, getDocs } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';
import Failure from '../../../core/Failure';

async function getScenarios(): Promise<Scenario[]> {
  try {
    const db = firestore;

    // Query all scenarios
    const scenarioCollectionRef = collection(db, FirestoreCollections.scenarios);
    const scenarioSnapshot = await getDocs(scenarioCollectionRef);

    if (scenarioSnapshot.empty) {
      return [];
    }

    // Loop results and map to Scenario model
    const aScenarios: Scenario[] = [];
    scenarioSnapshot.forEach((doc) => {
      aScenarios.push(Scenario.fromFirestore(doc));
    });

    return aScenarios;
  } catch (e) {
    console.log('error: ', e);
    throw new GetScenariosFailure();
  }
}

export class GetScenariosFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getScenarios;
